var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"value":_vm.value,"placeholder":"¿En qué estas pensando?","rows":"2","auto-grow":"","hint":"¡Puedes pegar enlaces de YouTube o Spotify para compartirlos!"},on:{"input":(e) => _vm.$emit('input', e),"paste":_vm.handlePaste}})
}
var staticRenderFns = []

export { render, staticRenderFns }